import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchResourceContributions, } from "../redux/actions";
import {
    userSelector, resourceContributionSelector, rankSelector,
} from "../redux/selectors";
import { toArray } from '../common/util';
import { Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import Username from "../common/Username";


class DKPResourceContributions extends Component {

    componentDidMount() {
        this.props.getContributions(this.props.section.chapter, this.props.section.slug, this.props.resource.slug)
    }
    render() {
        return (
            <div>
                {toArray(this.props.resourceContributions.data)
                    .filter((contrib) => contrib.resource.id === this.props.resource.id)
                    .sort((a, b) => (new Date(b.created).getTime() - new Date(a.created).getTime()))
                    .map((contrib) => (
                        <div className="panel-adt">
                            <Row>
                                <Col md={2}><Username user={this.props.users[contrib.userDetail]} rank={this.props.ranks[this.props.users[contrib.userDetail].rank]} /></Col>
                                <Col md={2}>{contrib.amount}</Col>
                                <Col md={2}>{contrib.description}</Col>
                                <Col md={2}><Moment fromNow>{contrib.created}</Moment></Col>
                            </Row>
                        </div>
                    ))}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    users: userSelector(state),
    ranks: rankSelector(state),
    resourceContributions: resourceContributionSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getContributions: (chapter, section, resource) => dispatch(fetchResourceContributions(chapter, section, resource)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DKPResourceContributions);


// WEBPACK FOOTER //
// ./src/DKP/DKPResourceContributions.js